import { render, staticRenderFns } from "./lp-live-market-purchase-2.vue?vue&type=template&id=53fda7cc&scoped=true"
import script from "./lp-live-market-purchase-2.vue?vue&type=script&lang=js"
export * from "./lp-live-market-purchase-2.vue?vue&type=script&lang=js"
import style0 from "./lp-live-market-purchase-2.vue?vue&type=style&index=0&id=53fda7cc&prod&scoped=true&lang=css"
import style1 from "./lp-live-market-purchase-2.vue?vue&type=style&index=1&id=53fda7cc&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fda7cc",
  null
  
)

export default component.exports